module.exports = function() {
  return new Worker("/" + "download.worker.7cf6a579262b262eb891.js");
};